module.exports = __webpack_public_path__ + "img/why-mentalfuture.15052e8f.png";